import { Navigate, useLocation } from 'react-router';
import type { ReactNode } from 'react';

import { useSession } from '../providers/sessionContext.js';
import { LoadingState } from '../../shared/ui/LoadingState.js';

/**
 * Route guard. This is UX only — it is NOT the security boundary: every row is protected
 * by PostgreSQL RLS regardless of what the client renders (skill 18.1).
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const session = useSession();
  const location = useLocation();

  if (session.status === 'loading') {
    return <LoadingState label="Đang kiểm tra đăng nhập…" />;
  }

  if (session.status === 'signedOut') {
    return <Navigate to="/dang-nhap" replace state={{ from: location.pathname }} />;
  }

  return children;
}
